import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';

const initialState = {
  campaigns: {}, 
  loading: false,
  error: null,
  pagination: {},
  selectedCampaign:null
};

/* ================== THUNKS ================== */

export const fetchAdCampaigns = createAsyncThunk(
  'ad-campaigns/fetch',
  async ({ fetchType = "table", page = 1, limit = 10, search = '' }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get('/api/admin/ad-campaigns', {
          params: { fetchType, page, limit, search }
        });
        return {
            data: response.data?.data?.records || [],
            pagination: response.data?.data?.pagination || {},
        };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const createAdCampaign = createAsyncThunk(
  'ad-campaigns/create',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        '/api/admin/ad-campaigns', 
        payload
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data);
    }
  }
);

export const fetchAdCampaignById = createAsyncThunk(
  'ad-campaigns/fetchById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/api/admin/ad-campaigns/${id}`);
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const updateAdCampaign = createAsyncThunk(
  'ad-campaigns/update',
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`/api/admin/ad-campaigns/${id}`, formData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data);
    }
  }
);

export const deleteAdCampaign = createAsyncThunk(
  'ad-campaigns/delete',
  async ({ id }, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`/api/admin/ad-campaigns/${id}`);
      return { id };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const sendAdCampaign = createAsyncThunk(
  'ad-campaigns/send',
  async ({id}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`/api/admin/ad-campaigns/send/${id}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const changeStatusCampaign = createAsyncThunk(
  'ad-campaigns/change-status',
  async ({id, status}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(`/api/admin/ad-campaigns/${id}/change-status`,{status});
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);



/* ================== SLICE ================== */

const adCampaignSlice = createSlice({
  name: 'ad-campaigns',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
        /* FETCH */
        .addCase(fetchAdCampaigns.pending, (state) => {
            state.loading = true;
        })
        .addCase(fetchAdCampaigns.fulfilled, (state, action) => {
            const { data, pagination } = action.payload;
            state.loading = false;
            state.pagination = pagination;
            state.campaigns = data;
        })
        .addCase(fetchAdCampaigns.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(fetchAdCampaignById.fulfilled, (state, action) => {
            state.loading = false;
            state.selectedCampaign = action.payload;
        })
        .addCase(fetchAdCampaignById.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        /* UPDATE */
        .addCase(updateAdCampaign.fulfilled, (state, action) => {        
            console.log(state,'state');
        })
        .addCase(updateAdCampaign.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(sendAdCampaign.fulfilled, (state, action) => {
            state.loading = false;
            
        })       
        .addCase(changeStatusCampaign.fulfilled, (state, action) => {
            state.loading = false;
            const updated = action.payload?.data;
            if (updated) {
                state.campaigns = state.campaigns.map((c) =>
                    c.id === updated.id ? updated : c
                );

                state.selectedCampaign = updated;
            }
        })       
        /* DELETE */
        .addCase(deleteAdCampaign.fulfilled, (state, action) => {
          state.campaigns = state.campaigns.filter((p) => p._id !== action.payload);
        });
  }
});

export default adCampaignSlice.reducer;